import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CrewMerchantApi } from 'corso-types';
import api from '~/api';
import {
  shippingClaimQueryKey,
  useShippingClaim,
} from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export type ShippingClaimRestore = CrewMerchantApi.RequestBody<
  '/:storeId/shipping-protection/claim/:shippingClaimId/restore',
  'post'
>;

export function useShippingClaimRestore() {
  const storeId = useStoreId();
  const shippingClaim = useShippingClaim();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: ShippingClaimRestore) =>
      api
        .store(storeId)
        .shippingProtection.claim(`${shippingClaim.id}`)
        .restore(body),
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: shippingClaimQueryKey(shippingClaim.id, storeId),
      });
      // the claims list shows status
      await queryClient.invalidateQueries({ queryKey: ['shippingClaims'] });
    },
  });
}
